import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useRouteError } from "react-router";
import { TextMain } from "ui";

export function ErrorBoundary() {
  const error = useRouteError() as Error;
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <TextMain>Something went wrong, please try again</TextMain>;
}
